const state = {
  questions: []
};

export default state;
